var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgListCard = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_902_108)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0H4.5V4H0.5V0ZM0.5 6H4.5V10H0.5V6ZM0.5 12H4.5V16H0.5V12ZM6.5 0H10.5V4H6.5V0ZM6.5 6H10.5V10H6.5V6ZM6.5 12H10.5V16H6.5V12ZM12.5 0H16.5V4H12.5V0ZM12.5 6H16.5V10H12.5V6ZM12.5 12H16.5V16H12.5V12Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_902_108"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgListCard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/list-card.97a0588a904ee502f5b233812504edbe.svg";